var _rect, _circle, _circle2, _g, _g2, _g3, _g4, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyStoryAfaanOromo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "#f8f9fa",
    rx: 20,
    ry: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 100,
    fill: "#e9ecef",
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 100,
    fill: "#e9ecef",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 300)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -70,
    r: 40,
    fill: "#ffb703",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: -75,
    r: 5,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: -75,
    r: 5,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10,-55 Q0,-45 10,-55",
    stroke: "#333",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-30 L0,80",
    stroke: "#333",
    strokeWidth: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-60,30",
    stroke: "#333",
    strokeWidth: 6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60,-20",
    stroke: "#333",
    strokeWidth: 6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,-20 L100,10",
    stroke: "#333",
    strokeWidth: 6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,80 L-30,150",
    stroke: "#333",
    strokeWidth: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,80 L30,150",
    stroke: "#333",
    strokeWidth: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -70,
    r: 35,
    fill: "#fb8500",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -12,
    cy: -75,
    r: 4,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: -75,
    r: 4,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8,-55 Q0,-45 8,-55",
    stroke: "#333",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-35 L0,70",
    stroke: "#333",
    strokeWidth: 7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-5 L-50,20",
    stroke: "#333",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-5 L50,20",
    stroke: "#333",
    strokeWidth: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,70 L-25,140",
    stroke: "#333",
    strokeWidth: 7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,70 L25,140",
    stroke: "#333",
    strokeWidth: 7,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 150)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -50,
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 28,
    fill: "#333",
    textAnchor: "middle"
  }, "Afaan Oromo"), /*#__PURE__*/React.createElement("path", {
    d: "M-80,0 Q0,-40 80,0 Q100,50 80,100 Q0,60 -80,100 Q-100,50 -80,0 Z",
    fill: "white",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -10,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#333",
    textAnchor: "middle"
  }, "Akkam jirta?"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#666",
    textAnchor: "middle"
  }, "(How are you?)"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 50,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#333",
    textAnchor: "middle"
  }, "Nagaan"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 80,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#666",
    textAnchor: "middle"
  }, "(Peace/I am fine)"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 450)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 60,
    fill: "#8d6e63",
    stroke: "#5d4037",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40,-20 Q0,-80 40,-20",
    fill: "#5d4037",
    stroke: "#3e2723",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -20,
    cy: 10,
    r: 15,
    fill: "#3e2723"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 10,
    r: 15,
    fill: "#3e2723"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 450)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -50,
    width: 100,
    height: 100,
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50,-50 L50,50 M50,-50 L-50,50",
    stroke: "#ff6b00",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "none",
    stroke: "#ff6b00",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -25,
    width: 50,
    height: 50,
    fill: "none",
    stroke: "#ff6b00",
    strokeWidth: 3
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 550,
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 24,
    fill: "#ff6b00",
    textAnchor: "middle"
  }, "Learning Journey")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyStoryAfaanOromo);
export default __webpack_public_path__ + "static/media/my-story-afaan-oromo.256f0bb034770151c4b723d3f4c01d43.svg";
export { ForwardRef as ReactComponent };